import { combineReducers } from "redux";
import Settings from "./Settings";
import Common from "./Common";
import { connectRouter } from "connected-react-router";
import Auth from "./Auth";
import Contact from "./Contact";
import Missing from "./Missing";
import EtcMissing from "./EtcMissing";
import Found from "./Found";
import Admin from "./Admin";
import Payment from "./Payment";
export default (history) =>
  combineReducers({
    router: connectRouter(history),
    settings: Settings,
    auth: Auth,
    common: Common,
    contact: Contact,
    missing: Missing,
    etcMissing: EtcMissing,
    found: Found,
    admin: Admin,
    payment: Payment,
  });
